import React from 'react';
import './CloudBackground.scss';
const CloudBackground = () => {
  return <div className='CloudBackground' />;
};

export default CloudBackground;
